var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export var allowed = function (_a) {
    var inHeader = _a.inHeader, columnKey = _a.columnKey, headers = _a.headers, forwardedRef = _a.forwardedRef, rest = __rest(_a, ["inHeader", "columnKey", "headers", "forwardedRef"]);
    return rest;
};
export default allowed;
